import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class LadderUp extends LevelChangerThing {
	static key = "LadderUp";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static deserialize(data: any): LadderUp {
		const l = new LadderUp(deserializeXY(data.xy), data.destinationLevel);
		l.visualId = data.visualId;
		return l;
	}
}
